import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '~/hooks';

const AuthRoute = ({ component, roleId = null, ...props }) => {
    let authCtx = useAuth();

    if (!authCtx.user) {
        return (
            <Redirect to='/login' push />
        );
    }

    let validRole = false;
    if (roleId){
        roleId.forEach((id) => {
            if (authCtx.hasRole(id)) { 
                validRole = true;
            } 
        });
    }

    return validRole || !roleId
        ? (<Route {...props} component={component} />) 
        : (<Redirect to='/unauthorized' push />);
};

export default AuthRoute;